import * as React from "react";
import { MeetingObj } from "../../Entity/Objmeeting";
import Report from "./Report";
import "./Report.scss";
//import { getId } from 'office-ui-fabric-react/lib/Utilities';
export interface IMeetingsProps {
  meetings: MeetingObj[];
  UpdateMethod;
  LogTitle;
  InsideCRM;
  CRMURL;
  Phrases;
  Progress;
  meetingcontacts;
  forcontactcard?;
  RefreshCRMData;
}
export default class Reports extends React.Component<IMeetingsProps> {
  constructor(props) {
    super(props);
  }
  public componentDidMount() {}
  public render() {
    return (
      <div className="crmreport">
        {this.props.meetings.map((meetingobj, index) => {
          let links='';
          if(meetingobj.ContactId && meetingobj.ContactId!='' && this.props.meetingcontacts){
             links = this.props.meetingcontacts[meetingobj.ContactId]
            ? this.props.meetingcontacts[meetingobj.ContactId]
            : "";
          }
          let thumbclass=this.props.forcontactcard?"meetingthumbitem":'';
          // let keyval=getId('crmmeeting');
          let keyval=this.props.forcontactcard?"crmmeetingrecnt"+meetingobj.ID:"crmmeeting"+meetingobj.ID;
          return (
            <div className={thumbclass} key={keyval}>
              <Report
                meeting={meetingobj}
                LogTitle={this.props.LogTitle}
                UpdateMethod={this.props.UpdateMethod}
                InsideCRM={this.props.InsideCRM}
                CRMURL={this.props.CRMURL}
                Phrases={this.props.Phrases}
                contactlinks={links}
                RefreshCRMData={this.props.RefreshCRMData}
              />
            </div>
            
          );
        })}
      </div>
    );
  }
}
